import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const THEME_OPTIONS = [
  { value: 'dark', label: 'Dark Mode' },
  { value: 'light', label: 'Light Mode' },
];

export const ThemeProvider = ({ children }) => {
  // Dark mode retired — light is the standard theme.
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    localStorage.setItem('equipr-theme', 'light');
    document.documentElement.setAttribute('data-app-theme', 'light');
  }, [theme]);

  const toggleTheme = () => setTheme('light');

  const isDark = false;
  const isLight = true;

  return (
    <ThemeContext.Provider value={{
      theme,
      setTheme,
      toggleTheme,
      isDark,
      isLight,
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
